import { forwardRef, ComponentPropsWithoutRef } from 'react';
import { ICurrentCity } from '~/src/store/reducers/city';
import { Logo, LogoImg } from './styled';
import LogoDefault from '~/static/images/header/logo-new.svg';

interface IProps extends ComponentPropsWithoutRef<'a'> {
  billingDomain?: string;
  cityData: ICurrentCity;
  href: string;
  maxWidth?: string;
}

const MenuLogo = forwardRef<HTMLAnchorElement, IProps>(
  ({ href, maxWidth }, ref): JSX.Element => {
    const logoImg = LogoDefault;

    return (
      <Logo href={href} data-test='menu-logo' ref={ref}>
        <LogoImg
          width='244'
          height='53'
          data-test='menu-logo-img'
          src={logoImg}
          alt={'Логотип Дом.ру'}
          maxWidth={maxWidth}
        />
      </Logo>
    );
  }
);
MenuLogo.displayName = 'ForwardedMenuLogo';
export default MenuLogo;
